import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import { Hello } from './pages/Hello.js';
import { WikiShell } from './pages/WikiShell.js';
import { WikiPage } from './pages/WikiPage.js';
import { WikiIndex } from './pages/WikiIndex.js';
import { WikiEditor } from './pages/WikiEditor.js';
import { EntityCreate } from './pages/EntityCreate.js';
import { WikiGroupOverview } from './pages/WikiGroupOverview.js';
import { GmLogin, GmLogout } from './pages/GmLogin.js';
import { AdventuresIndex } from './pages/AdventuresIndex.js';
import { AdventurePage } from './pages/AdventurePage.js';
import { EncounterIndex } from './pages/EncounterIndex.js';
import { EncounterGm } from './pages/EncounterGm.js';
import { BattleTracker } from './pages/BattleTracker.js';
import { RoomJoin } from './pages/RoomJoin.js';
import { RoomPlay } from './pages/RoomPlay.js';
import { BattleScene } from './pages/BattleScene.js';

export function App(): JSX.Element {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/wiki" replace />} />

        {/* GM-вхід: /gm/<secret> → запам'ятати у localStorage → /wiki */}
        <Route path="/gm/:secret" element={<GmLogin />} />
        <Route path="/gm" element={<GmLogout />} />

        {/* Конструктор сутності — повноекранний (власна палітра-ліва зона) */}
        <Route path="/wiki/new" element={<EntityCreate />} />
        <Route path="/wiki/:slug/build" element={<EntityCreate />} />

        <Route path="/wiki" element={<WikiShell />}>
          <Route index element={<WikiIndex />} />
          <Route path="new-md" element={<WikiEditor mode="new" />} />
          {/* `_/<group_path>` — overview-сторінка з плитками. Перед :slug, бо `_` — slug-валідний символ */}
          <Route path="_/*" element={<WikiGroupOverview />} />
          <Route path=":slug" element={<WikiPage />} />
          <Route path=":slug/edit" element={<WikiEditor mode="edit" />} />
        </Route>

        <Route path="/adventures" element={<AdventuresIndex />} />
        <Route path="/adventures/:slug" element={<AdventurePage />} />

        {/* Бойова сцена (VTT, дизайн «Бойова сцена») */}
        <Route path="/battle" element={<BattleScene />} />

        {/* Real-time encounter (Ф3-Ф6) */}
        <Route path="/encounters" element={<EncounterIndex />} />
        <Route path="/encounter/:id" element={<EncounterGm />} />
        <Route path="/encounter/:id/track" element={<BattleTracker />} />
        <Route path="/room/:id/join" element={<RoomJoin />} />
        <Route path="/room/:id/play" element={<RoomPlay />} />

        <Route path="/_dev/hello" element={<Hello />} />
        <Route path="*" element={<Navigate to="/wiki" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
